// extracted by mini-css-extract-plugin
export default {"info":"D0qx","h-rule":"Pfrj","hRule":"Pfrj","logo":"dsN0","further-resources":"QmgB","furtherResources":"QmgB"};